import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";


export default {
    
    getAll,
    editData,
    getEstatesByGroupID,
    getPaymentCalculationData,
    getDivisionByEstateID,
    updatePaymentCalculation
    
};

async function getAll(){
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function editData(data) {
    data.groupName = data.groupName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Group/UpdateGroup', null, data);
    return response;
}


async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + parseInt(id));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}


async function getPaymentCalculationData(groupID, estate, divisionID, registrationNumber, date) {
    //     var result = {
    //     groupID : parseInt(data.groupID),
    //     operationalEntityID : parseInt(data.estate),
    //     collectionPointID : parseInt(data.divisionID),
    //     registrationNumber : data.registrationNumber
      
    // }
    const response = await CommonGet('/api/RevenueSharedPaymentCalculation/GetDetailsForPaymentCalcualtion', 'groupID=' + groupID + '&estate=' + estate + '&divisionID=' + divisionID 
    + '&registrationNumber=' + registrationNumber + '&date=' + date);
    return response.data;
    
}

async function updatePaymentCalculation(paymentListModel) {
    
     let model = {
        paymentListModel: paymentListModel,
        
    //     // accountID: parseInt(model.accountID),
    //     // registrationNumber: model.registrationNumber,
    //     // employeeCode: model.employeeCode,
    //     // employeeName: model.firstName,
    //     // cardNumber: model.cardNumber,
    //     // harvesting: parseInt(model.harvesting),
    //     // weedCondition: parseInt(model.weedCondition),
    //     // conditionType: parseInt(model.conditionType),
    //     // isActive: model.isActive,
    //     // createdBy: model.getUserIDFromToken(),
    //     // createdDate: new Date().toISOString(),
       }
    const response = await CommonPost('/api/RevenueSharedPaymentCalculation/UpdatePaymentCalculation', null, model);
    return response;
  }


